import { getCompareIds, clearCompare } from "./compare";

function isOnComparePage(): boolean {
    return window.location.pathname.replace(/\/+$/, "") === "/porownaj";
}

// Użytkownicy przeoczają pasek porównania (patrz .compare-bar-intro w CSS) - żeby zwrócić na
// niego uwagę, ale tylko raz w życiu przeglądarki, a nie za każdym dodaniem kogoś do porównania.
const COMPARE_INTRO_SEEN_KEY = "mumin_compare_intro_seen";

function shouldShowIntroAnimation(): boolean {
    try {
        return !localStorage.getItem(COMPARE_INTRO_SEEN_KEY);
    } catch {
        return false;
    }
}

function markIntroAnimationSeen(): void {
    try {
        localStorage.setItem(COMPARE_INTRO_SEEN_KEY, "1");
    } catch { /* ignore */ }
}

// Pływający pasek widoczny na każdej stronie, gdy koszyk porównania nie jest pusty
// (analogicznie do paska koszyka w sklepie). Nie ma sensu go pokazywać, gdy użytkownik
// jest już na stronie porównania.
function renderBar(): void {
    const ids = getCompareIds();
    let bar = document.getElementById("compare-bar");

    if (ids.length === 0 || isOnComparePage()) {
        if (bar) bar.remove();
        return;
    }

    const isFreshlyCreated = !bar;
    if (!bar) {
        bar = document.createElement("div");
        bar.id = "compare-bar";
        bar.className = "compare-bar";
        document.body.appendChild(bar);
    }

    // Tylko przy PIERWSZYM w ogóle pojawieniu się paska (nie przy każdym kolejnym dodaniu do
    // porównania) - stąd warunek na isFreshlyCreated (pasek dopiero co powstał, czyli koszyk
    // był przed chwilą pusty) razem z shouldShowIntroAnimation (flaga na całe życie przeglądarki,
    // nie tej jednej wizyty na stronie).
    if (isFreshlyCreated && shouldShowIntroAnimation()) {
        bar.classList.add("compare-bar-intro");
        markIntroAnimationSeen();
    }

    bar.replaceChildren();

    const countEl = document.createElement("span");
    countEl.className = "compare-bar-count";
    countEl.textContent = `Do porównania: ${ids.length}`;

    const link = document.createElement("a");
    link.href = "/porownaj/";
    link.className = "compare-bar-link";
    link.textContent = "Zobacz porównanie";

    const clearBtn = document.createElement("button");
    clearBtn.type = "button";
    clearBtn.className = "compare-bar-clear";
    clearBtn.textContent = "Usuń";
    clearBtn.setAttribute("aria-label", "Usuń wszystkich z porównania");
    clearBtn.addEventListener("click", () => {
        clearCompare();
    });

    bar.append(countEl, link, clearBtn);
}

renderBar();
window.addEventListener("compare-changed", renderBar);
window.addEventListener("storage", renderBar);
window.addEventListener("pageshow", renderBar);
